<template>
  <v-layout>
    <v-flex>
      <template v-if="currentCreative">
        <template v-if="loading">
          <v-btn loading flat />
        </template>
        <template v-else>
          <template v-if="isBanner">
            <v-subheader>{{ creative.name }}を表示中</v-subheader>
            <v-divider class="mb-2" />
            <BannerDetail :creative="creative" hide-feedbacks hide-status>
              <template v-slot:append>
                <v-flex>
                  {{ creative.name }}
                  <a @click="openCreativePage">
                    編集
                    <v-icon small>new_tab</v-icon>
                  </a>
                </v-flex>
              </template>
            </BannerDetail>
          </template>
          <template v-else-if="isInfeed">
            <v-subheader>{{ creative.name }}を表示中</v-subheader>
            <v-divider class="mb-2" />
            <InfeedDetail
              :creative="creative"
              :mainImage="infeedMainImage"
              :iconImage="infeedIconImage"
              hide-feedbacks
              hide-status
            />
          </template>
          <template v-else>
            <template v-if="loading">
              <v-btn loading flat />
            </template>
            <template v-else>
              プレビューできません。
            </template>
          </template>
        </template>
      </template>
      <v-layout mt-4>
        <v-flex v-if="!currentCreative" class="xs4">
          クリエイティブを選択してください。
        </v-flex>
        <v-flex
          v-if="isBanner"
          :class="['xs8 text-xs-right', { 'offset-xs4': currentCreative }]"
          style="color: red"
        >
          ※ バナーをひもつける場合、320×50px と 300×250pxの2つは必須です。
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import BannerDetail from '../Creative/BannerDetail.vue'
import { BannerModel, InfeedModel } from '@/models/Creative'
import InfeedDetail from '../Creative/InfeedDetail.vue'
import AssetApi from '@/api/Asset'

export default {
  name: 'CampaignModalPageCreativePreview',
  components: { BannerDetail, InfeedDetail },
  props: {
    currentCreative: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      creative: null,
      infeedMainImage: null,
      infeedIconImage: null,
    }
  },
  computed: {
    isBanner() {
      return this.creative instanceof BannerModel
    },
    isInfeed() {
      return this.creative instanceof InfeedModel
    },
  },
  watch: {
    currentCreative() {
      this.loadDetail()
    },
  },
  methods: {
    async loadDetail() {
      if (!this.currentCreative) return
      this.loading = true
      this.creative = null
      try {
        this.creative = await this.currentCreative.getDetail()
        if (!this.isInfeed) return
        if (this.creative.mainImageId !== undefined) {
          this.infeedMainImage = await AssetApi.getAsset(
            this.creative.mainImageId,
          )
        }
        if (this.creative.iconImageId !== undefined) {
          this.infeedIconImage = await AssetApi.getAsset(
            this.creative.iconImageId,
          )
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    openCreativePage() {
      const { agencyId, advertiserId } = this.$route.params
      const url = `/agencies/${agencyId}/advertisers/${advertiserId}/creatives`
      const params = new URLSearchParams({
        action: 'edit',
        creativeFolderId: this.creative.creativeFolderId,
        ownerProfileId: this.currentCreative.ownerProfileId,
        creativeId: this.creative.id,
      })
      window.open(`${url}#${params}`)
    },
    async reload() {
      this.loadDetail()
    },
  },
}
</script>

<style></style>
